module.exports = __webpack_public_path__ + "img/obs_swstg_start.ea5576f0.svg";